module.exports = __webpack_public_path__ + "img/scan.42d50bb3.png";